import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FilterItem, InternalFilterGroup } from 'app/shared/models/filter-group.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-generic-input-filter',
    templateUrl: './generic-input-filter.component.html',
    styleUrls: ['./generic-input-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericInputFilterComponent implements OnInit {
  @Input() filter: InternalFilterGroup;
  dataToView: FilterItem[] = [];
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filter) {
      this.dataToView = UtilityFunctions.DeepClone(this.filter.data);
    }
  }

}
